var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "modal",
    attrs: {
      size: _vm.size,
      options: { close: { onBlur: false, onEsc: false } }
    },
    on: {
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "modal-title",
          fn: function() {
            return [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.title) +
                    " " +
                    _vm._s(
                      _vm.resource("JourneyComposer_BrickSettingsBase_Title")
                    )
                )
              ])
            ]
          },
          proxy: true
        },
        {
          key: "modal-body",
          fn: function() {
            return [
              _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col-4" }, [
                  _c("label", { attrs: { for: _vm.fieldName } }, [
                    _vm._v(_vm._s(_vm.fieldName))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-8" },
                  [
                    _c("input-group", { attrs: { icon: "far fa-edit" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newName,
                            expression: "newName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: _vm.fieldName,
                          name: _vm.fieldName,
                          type: "text",
                          disabled: !_vm.canWrite
                        },
                        domProps: { value: _vm.newName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newName = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.showError
                      ? _c("required", { attrs: { fieldName: _vm.fieldName } })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._t("default")
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c("settings-controls", {
                attrs: { disableSave: _vm.showError, prompt: _vm.promptValues },
                on: {
                  save: _vm.handleSave,
                  cancel: function($event) {
                    return _vm.$refs.modal.hide()
                  },
                  delete: _vm.handleDelete
                }
              })
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }